import React, { useState, useEffect } from 'react';
import './pitapit.css';
import logo from "../common/media/cc_logo_color.svg";
import logoWhite from "../common/media/cc_logo_white.svg";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import ProjectsList from "../common/components/Projects/ProjectsList";
import { Carousel } from 'react-responsive-carousel';
import { useHistory } from "react-router-dom";
import { projects as getProjects } from '../common/api/projects';
import Popover from "../common/components/popover/popover.js";
import Footer from "../common/components/Footer";
import { formatNumber } from "../common/util/numberFormatter";
import { getMerchantCodeWithPrefix } from '../../tools/MyCCMerchantLinkGenerator';

const ClimateFriendlyTravellerPage = ({ fetchedImpact, merchantCode,  ...props }) => {

    const [country, setCountry] = useState("NZ");
    const history = useHistory();
    //const [flightsImpact, setFlightsImpact] = useState();
    const [projects, setProjects] = useState();
    const treeGrowthYears = fetchedImpact && !fetchedImpact.error && formatNumber(fetchedImpact.treeGrowthYears?.value);
    const treeMetric = `An average tree captures about 20kg of carbon dioxide per year, and about 1 tonne over its lifetime. By funding projects that offset carbon emissions, we are having the same impact as ${treeGrowthYears} trees have in one year.`;
    const planChosen = () => {
        history.push("subscribe/payment");
    };

    const GetFlightSuffix = (unit) => {
        if (unit == "km") {
            return "kms";
        }
        return unit;
    };



    useEffect(() => {
        //flightsImpactApi().then(response => response.json()).then(data => setFlightsImpact(data));
        getProjects(null, merchantCode)
            .then(response => response.json())
            .then(data => setProjects(data))
            .catch(setProjects);

    }, []);

    useEffect(() => {
        console.log(country)
        if (country) {
            //impactApi.flights();
            //props.actions.loadProjects(country, props.merchantCode);
            // props.actions.getAllFlightsImpact(`en_${country}`);
        }
    }, [country]);

    useEffect(() => {
        //trackAdditionalPageView('pitapit-landing-page')
    }, []
    );

    return (
        <div>
            <div className="h-85vh w-100 position-relative img-cover hero-img vertical-align-parent" >
                <div className="container color-black text-left vertical-align">
                    <div className="mobile-hide">
                        <div className="w-fit text-center center">
                            <img className="center" style={{ height: "64px" }} src="https://res.cloudinary.com/carbonclick/image/upload/v1608606692/Enterprise/PitaPit/Logo_a9wm5w.svg" />
                            <div className="d-flex align-center text-center">
                                <div>
                                    <img src={'https://res.cloudinary.com/carbonclick/image/upload/v1622428425/Enterprise/PitaPit/pins-left_g959hi.svg'} />
                                </div>
                                <h1 className="mb-4 text-shadow mt-0 color-primary">Pita Pit Climate Positive<br/>School Lunches</h1>
                                <div>
                                    <img src={'https://res.cloudinary.com/carbonclick/image/upload/v1622428423/Enterprise/PitaPit/pins-right_zhswe4.svg'} />
                                </div>
                            </div>
                            <div className="d-flex w-fit center">
                                <h5 className="mr-2 mt-0 font-bold">Climate Positive by</h5>
                                <div>
                                    <a target="_blank" href="https://www.carbonclick.com/"><img style={{ height: 30 }} src={logo} /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mobile-show text-center">
                        <div className="w-fit text-center">
                            <img className="center" style={{ height: "56px" }} src="https://res.cloudinary.com/carbonclick/image/upload/v1608606692/Enterprise/PitaPit/Logo_a9wm5w.svg" />
                            <div className="d-flex align-center text-center">
                                <h1 className="mb-4 text-shadow mt-0 color-primary">Pita Pit Climate Positive<br/>School Lunches</h1>
                            </div>
                        </div>

                        </div>
                    </div>
                </div>

                <div className="mobile-show">
                    <div className="bg-primary p-3 text-center">
                        <div className="w-fit center color-white">
                            <div className="d-flex">
                                <h5 className="mr-2 font-bold mt-1 mb-0">Powered By</h5>
                                <div>
                                    <a target="_blank" href="https://www.carbonclick.com/"><img style={{ height: 30 }} src={logoWhite} /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="impact-img img-cover">
                    <div id="content" className="py-5 img-cover"> 
                        <div className="container text-center pt-5">
                            <div className="mb-3 center mw-720px mobile-hide">
                                <h2 className="font-bold">We are Making School<br />Lunches Climate Positive</h2>
                                <h4>Pita Pit has joined with CarbonClick to help bring delicious, healthy lunches to Kiwi kids, carbon free, through the Ka Ora Ka Ako School Lunch Programme.</h4>
                            </div>
                            <div className="mobile-show">
                                <h3 className="font-bold">We are making school lunches climate positive</h3>
                                <h5>Pita Pit has joined with CarbonClick to help bring delicious, healthy lunches to Kiwi kids, carbon free, through the Ka Ora Ka Ako School Lunch Programme.</h5>
                            </div>
                            <div className="py-5 mobile-hide">
                                <div className="center bg-primary py-5 px-3 color-white mb-3" >
                                    <h1 style={{ fontSize: "5rem" }} className="title pacifico-font mb-3">{formatNumber(fetchedImpact?.impactProgress?.lunches?.currentCount)}</h1>
                                    <h4 className="font-bold" >Climate Positive Ka Ora Ka Ako School Lunches</h4>
                                </div>

                                <div className="center mb-3">
                                    <div className="row text-left">

                                        <div className="col-6 d-grid">
                                            <div className="center bg-primary w-100">
                                                <div className="px-2 py-4 font-bold color-white">
                                                    <h1 className="pacifico-font">{formatNumber(fetchedImpact?.impactProgress?.carbonOffset?.currentCount)}</h1>
                                                    <h4 className="font-bold">Kg of CO2 Offset</h4>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-6 d-grid">
                                            <div className="center bg-primary w-100">
                                                <div className="px-2 py-4 font-bold color-white">
                                                    <h1 className="pacifico-font">{formatNumber(fetchedImpact?.impactProgress?.treeGrowthYears?.currentCount)}</h1>
                                                    <h4 className="font-bold"><span className="mr-2">Tree Growth Years</span>
                                                        <Popover content={treeMetric} >
                                                            <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20">
                                                                <path d="M0 0h24v24H0z" fill="none" />
                                                                <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" />
                                                            </svg>
                                                        </Popover>
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <a href="https://my.carbon.click/transaction/92c9eba0-e9d9-4dd4-a551-71e4c74e9dc1" target="_blank" className="btn btn-primary" >Trace Our Impact</a>
                            </div>

                            <div className="mobile-show pt-4">
                                <div className="text-center font-bold color-white bg-primary mb-3 py-4 px-2">
                                    <h2 className="pacifico-font" >{formatNumber(fetchedImpact?.impactProgress?.lunches?.currentCount)}</h2>
                                    <p>Climate Positive Ka Ora Ka Ako School Lunches</p>
                                </div>

                                <div className="mb-3">
                                    <div className="center bg-primary shadow w-100">
                                        <div className="px-2 py-4 font-bold color-white">
                                            <h2 className="pacifico-font">{formatNumber(fetchedImpact?.impactProgress?.carbonOffset?.currentCount)}</h2>
                                            <p>Kg of CO2 Offset</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="mb-3">
                                    <div className="center bg-primary shadow w-100">
                                        <div className="px-2 py-4 font-bold color-white">
                                            <h2 className="pacifico-font">{formatNumber(fetchedImpact?.impactProgress?.treeGrowthYears?.currentCount)}</h2>
                                            <p><span className="mr-2">Tree Growth Years</span>
                                                <Popover content={treeMetric} >
                                                    <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20">
                                                        <path d="M0 0h24v24H0z" fill="none" />
                                                        <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" />
                                                    </svg>
                                                </Popover>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <a href="https://my.carbon.click/transaction/92c9eba0-e9d9-4dd4-a551-71e4c74e9dc1" target="_blank" className="btn btn-primary" >Trace Our Impact</a>
                            </div>
                        </div>
                    </div>

                    <div className="py-5 mobile-p-0">
                        <div className="container text-left">
                            <div className="mb-5 center mw-720px">
                                <h2 className="font-bold">Better Food for a Better Planet</h2>
                                <p>Our team are committed to sustainability and are consciously working to reduce our environmental impact from our packaging to our produce.</p>
                            </div>
                            <div className="row">
                                <div className="col-4 d-grid mb-5">
                                    <img className="mw-100" src="https://res.cloudinary.com/carbonclick/image/upload/c_lfill,h_599,q_auto,w_508/v1624491039/Enterprise/PitaPit/The_Auckland_Airport_Team_6_fzm5ja.jpg" />
                                </div>
                                <div className="col-4 d-grid mb-5">
                                    <img className="mw-100" src="https://res.cloudinary.com/carbonclick/image/upload/c_lfill,h_599,q_auto,w_508/v1608606641/Enterprise/PitaPit/Img-2_cvqjed.png" />
                                </div>
                                <div className="col-4 d-grid mb-5">
                                    <img className="mw-100" src="https://res.cloudinary.com/carbonclick/image/upload/c_lfill,h_599,q_auto,w_508/v1608606642/Enterprise/PitaPit/Img-1_kko2pm.png" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="py-6" id="subscriptions">
                        <div className="container text-center">
                            <div className="mb-5 center mw-720px">
                                <h2 className="font-bold">Feeling Inspired? Let's Do More</h2>
                                <p>Purchase a carbon offset subscription to make an ongoing, traceable difference. We&apos;ll show you how your positive impacts grow each month.</p>
                            </div>

                            <div className="row">
                                <div className="col-lg-3 col-md-6 mb-3 d-grid">
                                    <div className="bg-white shadow-lg flex-column">
                                        <div className="img-cover h-160px w-100" style={{ backgroundImage: 'url(https://res.cloudinary.com/carbonclick/image/upload/v1602122540/CFT-Impact-CO2_bg5wqm.png)' }}>

                                        </div>
                                        <div className="px-3 pt-3 text-center flex-grow">
                                            <h4>Light</h4>
                                            <h5>$15 / Month</h5>
                                            <p>This will cover a portion of your monthly carbon footprint.</p>
                                        </div>
                                        <div className="px-3 pb-3 text-center">

                                            <a href={`${process.env.MY_CC_URL}/${getMerchantCodeWithPrefix(merchantCode)}/subscribe?recommendedPricingLevel=10`} className="btn btn-primary btn-lg mb-1 w-100 border-r4">Select</a>
                                          
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 mb-3 d-grid">
                                    <div className="bg-white shadow-lg flex-column">
                                        <div className="img-cover h-160px w-100" style={{ backgroundImage: 'url(https://res.cloudinary.com/carbonclick/image/upload/v1602121323/sample.jpg)' }}>

                                        </div>
                                        <div className="px-3 pt-3 text-center flex-grow">
                                            <h4>Everyday</h4>
                                            <h5>$24 / Month</h5>
                                            <p>For most people, this will cover the large part of their carbon footprint.</p>
                                        </div>
                                        <div className="px-3 pb-3 text-center">
                                            <a href={`${process.env.MY_CC_URL}/${getMerchantCodeWithPrefix(merchantCode)}/subscribe?recommendedPricingLevel=20`} className="btn btn-primary btn-lg mb-1 w-100 border-r4">Select</a>
                                           
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 mb-3 d-grid">
                                    <div className="bg-white shadow-lg flex-column">
                                        <div className="img-cover h-160px w-100" style={{ backgroundImage: 'url(https://res.cloudinary.com/carbonclick/image/upload/v1603051574/Global_ln6eok.png)' }}>

                                        </div>
                                        <div className="px-3 pt-3 text-center flex-grow">
                                            <h4>Family</h4>
                                            <h5>$49 / Month</h5>
                                            <p>Covers a good portion of a small family’s footprint.</p>
                                        </div>

                                        <div className="px-3 pb-3 text-center">
                                            <a href={`${process.env.MY_CC_URL}/${getMerchantCodeWithPrefix(merchantCode)}/subscribe?recommendedPricingLevel=30`} className="btn btn-primary btn-lg mb-1 w-100 border-r4">Select</a>
                                           
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 mb-3 d-grid">
                                    <div className="bg-white shadow-lg flex-column">
                                        <div className="img-cover h-160px w-100" style={{ backgroundImage: 'url(https://res.cloudinary.com/carbonclick/image/upload/v1602122540/CFT-Impact-Trees_pve5l8.png)' }}>

                                        </div>
                                        <div className="px-3 pt-3 text-center flex-grow">
                                            <h4>Hero</h4>
                                            <h5>$99 / Month</h5>
                                            <p>For climate rockstars! Cover your own climate footprint, and pay it forward to friends and family.</p>
                                        </div>
                                        <div className="px-3 pb-3 text-center">
                                            <a href={`${process.env.MY_CC_URL}/${getMerchantCodeWithPrefix(merchantCode)}/subscribe?recommendedPricingLevel=40`} className="btn btn-primary btn-lg mb-1 w-100 border-r4">Select</a>
                                           
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {
                                /*country && <PlansList
                                    selectedPlan={selectedPlan}
                                    onSelectedPlanChange={setSelectedPlan}
                                    planChosen={planChosen}
                                    country={country}
                                    setLocationModalVisible={setShowModal}
                                />*/
                            }
                        </div>
                    </div>
                </div>
                <div className="quote-img img-cover pt-5 pb-1" style={{ backgroundPosition: "left" }}>
                    <div className="container text-center">
                        <Carousel dynamicHeight={false} showThumbs={false} showArrows={false} showStatus={false} infiniteLoop={true} autoPlay={true}>

                            <div key="1" className="p-3 mb-4">
                                <div className="p-3">
                                    <div className="center mw-600px">
                                        <div className="Quote">
                                            <h4 >&apos;&apos;Pita Pit is doing their part for the community and planet by providing carbon neutral school lunches.&apos;&apos;</h4>
                                            <p className="font-bold">Eilish</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div key="2" className="p-3 mb-4">
                                <div className="p-3">
                                    <div className="center mw-600px">
                                        <div className="Quote">
                                            <h4 >&apos;&apos;As a big Pita Pit fan I love that they are helping to support Kiwi kids by providing great lunches while also supporting the environment.&apos;&apos;</h4>
                                            <p className="font-bold">John</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </Carousel>
                    </div>
                </div>

                {Array.isArray(projects) && <>
                    <div className="py-6">
                        <div className="container text-center">
                            <div className="mb-5 center mw-600px">
                                <h3 className="font-bold">Here are the projects we invest in to fight climate change</h3>
                                <p>Our program supports high quality and trusted projects around the world that share our mission of fighting climate change and protecting the planet.</p>
                            </div>
                            <div className="text-left mobile-text-center">
                                <ProjectsList title={null} projects={projects} />
                            </div>
                        </div>
                    </div>
                </>
                }
                <Footer />
            </div>
    )
}


export default ClimateFriendlyTravellerPage;